export default __webpack_public_path__ + "static/media/gallery-2.736c8c1f.jpg";